
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ReferralTrackingProvider } from "@/components/referral/ReferralTrackingProvider";
import { PWAInstallPrompt } from "@/components/ui/pwa-install-prompt";
import { MobileViewportOptimizer } from "@/components/mobile/MobileViewportOptimizer";
import { AppRoutes } from "@/Routes";

const queryClient = new QueryClient();

const App = () => {
  console.log('App component is rendering');
  return (
    <QueryClientProvider client={queryClient}>
      <ReferralTrackingProvider>
        <TooltipProvider>
          <MobileViewportOptimizer>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AppRoutes />
              <PWAInstallPrompt />
            </BrowserRouter>
          </MobileViewportOptimizer>
        </TooltipProvider>
      </ReferralTrackingProvider>
    </QueryClientProvider>
  );
};

export default App;
